<template>
    <div>
        <div>
            <img class="hbsc" src="~@public/img/hotApply/icon_hbsc.jpg">
        </div>
        <p class="title">长按图片，识别湖北社采小程序</p>
    </div>
</template>

<script>
    export default {
        name: "HuberMap"
    }
</script>
<style scoped>
    .hbsc {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
    .title{
        font-size: 0.5rem;
        text-align: center;
        color:black;
    }
</style>
